import { __exportAll } from "./_virtual/_rolldown/runtime.js";
//#region src/schema.ts
var schema_exports = /* @__PURE__ */ __exportAll({
	INT_MAX: () => INT_MAX,
	INT_MIN: () => INT_MIN,
	MAX_PREP_TIME_MINUTES: () => MAX_PREP_TIME_MINUTES
});
const INT_MIN = -9999999;
const INT_MAX = 99999999999;
const MAX_PREP_TIME_MINUTES = 1440;
//#endregion
export { INT_MAX, INT_MIN, MAX_PREP_TIME_MINUTES, schema_exports };

//# sourceMappingURL=schema.js.map